<style lang="less">
  @mw-black: #141414;
  @mw-green: #86BD60;

  .welcome-headline{
    font-size: 2.5em;
    font-weight: 200;
    text-transform: uppercase;
    color: #86BD60;
  }
  
  .border-1{
    border: 1px solid #ddd;
  }
  
  .text-light{
    font-weight: 400;
  }
  
  .text-small{
    font-size: 0.8em;
  }
  
  .text-larger{
    font-size: 1.8em;
    font-weight: 200;
  }

  #main-header{
    background-color: @mw-black !important;
    color: white !important;    
    .theme--light.v-btn.v-btn--icon{
      color: white !important;
    }
  }

  #main-sidebar{
    background-color: @mw-black !important;
    color: white;
    z-index: 15;
    a{
      color: white !important;
    }
    .v-list-item--active{
      color: @mw-green !important;
    } 
  }

  #logout{
    cursor: pointer;
  }

  #main{
    margin-left: 56px;
    padding-left: 25px !important;
    padding-right: 25px !important;
    background-color: #f5f5f5;
  }

  .mw-h1{
    font-weight: 100 !important;
    text-transform: uppercase;
    margin-bottom: 1.2rem;
    font-size: 1.9em;
    width: 100%; 
  }

  .mw-h0{
    font-weight: 100 !important;
    text-transform: uppercase;
    margin-bottom: 1.2rem;
    font-size: 2.5em;
    width: 100%; 
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  .mw-h2{
    font-weight: 100;
    text-transform: uppercase;
  }

  .mw-h3{
    text-transform: uppercase;
    color: grey;
    font-weight: 300;
  }

  ul.small-caps{
    text-transform: uppercase;
    font-size: 0.9em;
    color: grey;
    font-weight: 300;
    text-decoration: none;
    list-style: none;
    padding: 0px !important;
    margin: 0px;
  }

  .small-caps{
    text-transform: uppercase;
    font-size: 0.9em;
    color: grey;
    font-weight: 300;
  }

  a.styleless{
    text-decoration:  none;
    color: grey !important;
  }

  .text-large{
    font-size: 1.4em;
    font-weight: 200;
  }

  .text-medium{
    font-size: 1.2em;
    font-weight: 200;
  }

  .text-green{
  color: #86BD60 !important;
  }

</style>
<template>
  <div>
    <v-app id="hub">
      <Navigation></Navigation>
      <v-app-bar v-if="loggedIn" fixed flat color="#f5f5f5" >
        <v-toolbar-title>
          <span class="font-weight-thin hidden-sm-and-down" style="margin-left: 56px">Meisterworks Project Hub</span>
          <span v-if="view == 'client'" class="ml-3 mt-5" style="vertical-align: middle"> 
            <img :src="userDetails.logo" height="30px"/>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="font-weight-thin">Logged in as {{userDetails ? userDetails.displayName : user.email }}</span>
        <v-btn rounded small dark  v-if="now" :color="timezoneMatches ? 'green' : 'red'" class="ml-2" @click="timezoneDialog = 1"> 
          {{ now | moment('timezone', userTimezone, 'h:mm a') }}
          <v-tooltip bottom v-if="!timezoneMatches">
            <template v-slot:activator="{ on }" >
              <v-icon x-small class="pl-2" v-on="on">mdi-alert</v-icon>
            </template>
            You appear to be in a different timezone to the one associated with your profile. 
          </v-tooltip>
        </v-btn>
        <v-dialog v-model="timezoneDialog" width="500">
          <TimeZoneSelector :user="userDetails"></TimeZoneSelector>
        </v-dialog>
      </v-app-bar> 
      <v-content id="main">
        <div style="height: 50px" v-if="loggedIn"></div>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
      <Footer></Footer>
      <Chat></Chat>
    </v-app>
  </div>
</template>

<script>
import Vuex from 'vuex'
import Navigation from "../src/components/subpanels/Navigation.vue"
import Footer from "../src/components/subpanels/Footer.vue"
import client from "../src/store/modules/Client.js"
import admin from "../src/store/modules/Admin.js"
import visitor from "../src/store/modules/Visitor.js"
import panelmember from "../src/store/modules/PanelMember.js"
import TimeZoneSelector from "../src/components/tools/TimeZoneSelector.vue"
import * as mwTz from "../src/assets/timezoneFunctions.js"
import Chat from "../src/components/tools/Chat.vue"

export default {
  name: 'App',
  data: () => ({
    now: false,
    dialog: false,
    timezoneDialog: false,
  }),
  computed: {
    ...Vuex.mapState({
      view: state => state.auth.view,
      user: state => state.auth.user,
      userDetails: state => state[state.auth.view].user, 
      loggedIn: state => state.auth.logged_in,
      loggedOut: state => state.auth.logged_out
    }),
    browserTimezone(){
      return mwTz.browserTimezone();
    },
    userTimezone(){
      return mwTz.userTimezone(this.userDetails);
    },
    timezoneMatches(){
      return mwTz.timezoneMatches(this.userDetails);
    },
    onLoginPage: function(){
      return this.$route.name == 'login'
    } 
  },
  components: {
    TimeZoneSelector,
    Chat,
    Navigation,
    Footer
  },
  watch: {  
    $route() {
      document.title = 'MW X'
    },
    loggedOut: function(){
      if( !this.logged_in){
        this.$router.replace({ name: "home" });
      }
    },
    loggedIn: function(oldValue, newValue){
      if( oldValue !== newValue ){
        // this.$router.replace({ name: "home" });
      }
    },
    view: {
      immediate: true,
      handler(view) {
        if( !view ){
          return;
        }
        const self = this;
        self.$store.dispatch('checkUserStatus').then( () => {    } ).catch(() => {});
        switch(view){
          case "admin": 
          this.$store.registerModule("admin", admin)
          this.$store.dispatch("fetchUser");
          break;
          case "client": 
          this.$store.registerModule("client", client)
          this.$store.dispatch("fetchUser");
          break;
          case "panelmember": 
          this.$store.registerModule("panelmember", panelmember)
          this.$store.dispatch("fetchUser");
          break;
          default: 
          this.$store.registerModule("visitor", visitor )
          break;
        }
      }
    },
  },
  methods:{
    setTime(){
      this.now = new Date();
    },
    redirect: function(view){
      if( this.views[view] ){
        let to = this.views[view].redirect;
        if( to !== this.$route.name ){
          this.$router.replace({ name: to });
        }
      }
    }
  },
  created: function(){
    const self = this;
    setInterval(function(){
      self.setTime();
    }, 1000)
  },
  mounted(){
  }
}
</script>
